import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';

import {ButtonLink} from '@br/mg-components';

import {BuyOrActivateLicenseContext} from '../BuyOrActivateLicense';

const CreateNewTenantButton = ({partnerId, className = ''}: {partnerId?: string; className?: string}): JSX.Element => {
    const {t} = useTranslation(['licenses']);
    const {activateLicenseUrl: baseActivateLicenseUrl} = useContext(BuyOrActivateLicenseContext);

    /* eslint-disable i18next/no-literal-string */
    let url = `${baseActivateLicenseUrl}?action=newTenant`;
    if (partnerId) {
        url += `&partner=${partnerId}`;
    }
    /* eslint-enable i18next/no-literal-string */

    return (
        <ButtonLink
            appearance="primary"
            small
            href={url}
            className={`p-3 ${className}`}
        >
            {t('licenses:createNewTenantLicense', 'Create new tenant')}
        </ButtonLink>
    );
};

export default CreateNewTenantButton;
